import styled from 'styled-components';

export default styled.label`
  ${({ theme }) => theme.atoms?.label}
`;
